import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Rating from 'components/base/Rating';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Link } from 'react-router-dom';
import ActionDropdownItems from './ActionDropdownItems';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Brand } from 'api/categories/_requests';

const BrandItem = ({ brand }: { brand: Brand }) => {
  return (
    <RevealDropdownTrigger className="hover-actions-trigger">
      <div
        className="border border-translucent d-flex flex-center rounded-3 mb-3 p-4"
        style={{ height: 180 }}
      >
        <img className="mw-100" src={brand.image} alt={brand.name} />
      </div>
      <Link to={`/branddetails/${brand.slug}`} className="stretched-link">
        <h5 className="mb-1 text-truncate text-capitalize">{brand.name}</h5>
      </Link>

      {/* <RevealDropdown
        className="hover-actions top-0 end-0 mt-2 me-2"
        btnClassName="btn-icon"
      >
        <ActionDropdownItems />
      </RevealDropdown> */}
    </RevealDropdownTrigger>
  );
};

export default BrandItem;
